import React from "react";
import {
  AdminDetailFieldLabel,
  AdminHeaderAction,
  adminWizardInputClasses,
} from "../../AdminDashboard/shared/adminUx";
import { BUSINESS_FORM_ACTION_ROW_END_CLASS } from "../shared/businessLayoutSpec";

const TradingHours = () => {
  const fields = [
    { id: "weekdays", label: "Mon - Fri", placeholder: "9:00 AM - 5:00 PM" },
    { id: "saturday", label: "Saturday", placeholder: "10:00 AM - 3:00 PM" },
    { id: "sunday", label: "Sunday", placeholder: "Closed" },
    { id: "holiday", label: "Public holiday", placeholder: "Closed" },
  ];

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="w-full max-w-[480px] mx-auto">
        <div className="col-span-12">
          {fields.map((field, index) => (
            <div key={field.id} className={index > 0 ? "mt-5 space-y-1" : "space-y-1"}>
              <AdminDetailFieldLabel htmlFor={field.id}>{field.label}</AdminDetailFieldLabel>
              <input
                id={field.id}
                type="text"
                placeholder={field.placeholder}
                className={`${adminWizardInputClasses(false)} lg:bg-pastalblue`}
              />
            </div>
          ))}
          <div className={BUSINESS_FORM_ACTION_ROW_END_CLASS}>
            <AdminHeaderAction type="button">Save</AdminHeaderAction>
          </div>
        </div>
      </div>
    </form>
  );
};

export default TradingHours;
